import {
  ADDON_LIST_REQUEST,
  ADDON_LIST_SUCCESS,
  ADDON_LIST_FAIL,
  ADDON_LIST_RESET,
  ADDON_SINGLE_REQUEST,
  ADDON_SINGLE_SUCCESS,
  ADDON_SINGLE_FAIL,
  ADDON_SINGLE_RESET,
  CREATE_ADDON_REQUEST,
  CREATE_ADDON_SUCCESS,
  CREATE_ADDON_FAIL,
  CREATE_ADDON_RESET,
  UPDATE_ADDON_REQUEST,
  UPDATE_ADDON_SUCCESS,
  UPDATE_ADDON_FAIL,
  UPDATE_ADDON_RESET,
  DELETE_ADDON_REQUEST,
  DELETE_ADDON_SUCCESS,
  DELETE_ADDON_FAIL,
  DELETE_ADDON_RESET,
} from "constants/addonConstants";

export const listAddonsReducer = (state = { addonsList: [] }, action) => {
  switch (action.type) {
    case ADDON_LIST_REQUEST:
      return { loading: true };
    case ADDON_LIST_SUCCESS:
      return { loading: false, addonsList: action.payload };
    case ADDON_LIST_FAIL:
      return { loading: false, error: action.payload };
    case ADDON_LIST_RESET:
      return [];
    default:
      return state;
  }
};

export const singleAddonsReducer = (state = { addonSingle: {} }, action) => {
  switch (action.type) {
    case ADDON_SINGLE_REQUEST:
      return { loading: true };
    case ADDON_SINGLE_SUCCESS:
      return { loading: false, addonSingle: action.payload };
    case ADDON_SINGLE_FAIL:
      return { loading: false, error: action.payload };
    case ADDON_SINGLE_RESET:
      return [];
    default:
      return state;
  }
};

export const addonCreateReducer = (state = { newAddon: {} }, action) => {
  switch (action.type) {
    case CREATE_ADDON_REQUEST:
      return { loading: true };
    case CREATE_ADDON_SUCCESS:
      return { loading: false, newAddon: action.payload };
    case CREATE_ADDON_FAIL:
      return { loading: false, error: action.payload };
    case CREATE_ADDON_RESET:
      return { newAddon: {} };
    default:
      return state;
  }
};

export const addonUpdateReducer = (state = { updateAddon: {} }, action) => {
  switch (action.type) {
    case UPDATE_ADDON_REQUEST:
      return { loading: true };
    case UPDATE_ADDON_SUCCESS:
      return { loading: false, updateAddon: action.payload, success: true };
    case UPDATE_ADDON_FAIL:
      return { loading: false, error: action.payload };
    case UPDATE_ADDON_RESET:
      return { updateAddon: {} };
    default:
      return state;
  }
};

export const addonDeleteReducer = (state = { deleteAddon: {} }, action) => {
  switch (action.type) {
    case DELETE_ADDON_REQUEST:
      return { loading: true };
    case DELETE_ADDON_SUCCESS:
      return { loading: false, deleteAddon: action.payload, success: true };
    case DELETE_ADDON_FAIL:
      return { loading: false, error: action.payload };
    case DELETE_ADDON_RESET:
      return { deleteAddon: {} };
    default:
      return state;
  }
};
